/**
 * Reveal on scroll
 * Відслідковує всі елементи з класом .reveal і додає .is-visible коли вони у viewport.
 */

(function () {
    if (window.__revealOnScrollInit) return;
    window.__revealOnScrollInit = true;

    const ANIMATION_CLASS = 'is-visible';
    const THRESHOLD_DEFAULT = 0.2;
    const THRESHOLD_PRODUCT_CARDS = 0.7;
    const ROOT_MARGIN = '0px 0px 10% 0px'; // extend intersection root downward

    function createObserver(threshold) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add(ANIMATION_CLASS);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold, rootMargin: ROOT_MARGIN }
        );
        return observer;
    }

    function initReveal() {
        const observerDefault = createObserver(THRESHOLD_DEFAULT);
        const observerProductCards = createObserver(THRESHOLD_PRODUCT_CARDS);

        document.querySelectorAll('.reveal:not(.product-cards)').forEach((el) => {
            observerDefault.observe(el);
        });
        document.querySelectorAll('.reveal.product-cards').forEach((el) => {
            observerProductCards.observe(el);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initReveal);
    } else {
        initReveal();
    }
})();
